module.exports = __webpack_public_path__ + "img/ic_send.33c23b05.svg";